import { get, put, remove } from '../redux/api';
import type { FlagDescriptions, FlagName } from '../../shared/featureFlags/types';

/**
 * Gets a list of all flags that exist in the system with details about each flag
 */
export async function getAllExistingFlags(): Promise<FlagDescriptions | undefined> {
  const res = await get<{flags: FlagDescriptions}>('/api/feature_flags');
  return res?.data?.flags;
}

/**
 * Gets a list of flag names enabled for the current org
 */
export async function getFlagsForOrg(): Promise<FlagName[]> {
  const res = await get<{flags: FlagName[]}>('/api/feature_flags/org');
  return res?.data?.flags || [];
}

/**
 * Toggles a flag off for an organization
 * @param {FlagName} flag - The name of the flag to toggle off
 */
export async function turnFlagOff(flag: FlagName): Promise<void> {
  await remove<void, void>(`/api/feature_flags/org/${flag}`);
}

/**
 * Toggles a flag on for an organization
 * @param {FlagName} flag - The name of the flag to toggle off
 */
export async function turnFlagOn(flag: FlagName): Promise<void> {
  await put<void, void>(`/api/feature_flags/org/${flag}`, undefined);
}
